import React, { useState } from 'react'
import { useAuth } from '../../shared/contexts/AuthContext'

export const OAuthDebugger: React.FC = () => {
  const { signInWithGoogle } = useAuth()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleGoogleSignIn = async () => {
    setIsLoading(true)
    setError(null)
    
    try {
      console.log('Manual Google OAuth trigger...')
      await signInWithGoogle()
    } catch (err) {
      console.error('Google OAuth error:', err)
      setError(err instanceof Error ? err.message : 'Unknown error')
    } finally {
      setIsLoading(false)
    }
  }

  const testRedirectUrl = () => {
    const currentUrl = window.location.origin
    const callbackUrl = `${currentUrl}/auth/callback`
    console.log('Current URL:', currentUrl)
    console.log('Callback URL:', callbackUrl)
    alert(`Current URL: ${currentUrl}\nCallback URL: ${callbackUrl}`)
  }

  const checkPopupBlocked = () => {
    const popup = window.open('', '_blank', 'width=400,height=400')
    if (popup) {
      popup.close()
      alert('Popups are allowed')
    } else {
      alert('Popups are blocked! Please allow popups for this site.')
    }
  }

  return (
    <div className="fixed bottom-4 left-4 bg-blue-800 text-white p-4 rounded-lg shadow-lg z-50 max-w-sm">
      <h3 className="text-sm font-bold mb-2">OAuth Debugger</h3>
      
      <div className="space-y-2 text-xs">
        <button
          onClick={handleGoogleSignIn}
          disabled={isLoading}
          className="w-full px-2 py-1 text-xs bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 rounded"
        >
          {isLoading ? 'Loading...' : 'Test Google OAuth'}
        </button>
        
        <button
          onClick={testRedirectUrl}
          className="w-full px-2 py-1 text-xs bg-green-600 hover:bg-green-700 rounded"
        >
          Test Redirect URLs
        </button>
        
        <button
          onClick={checkPopupBlocked}
          className="w-full px-2 py-1 text-xs bg-yellow-600 hover:bg-yellow-700 rounded"
        >
          Check Popup Blocking
        </button>
      </div>
      
      {error && (
        <div className="mt-2 p-2 bg-red-600 rounded text-xs">
          Error: {error}
        </div>
      )}
      
      <div className="text-xs mt-2 opacity-75">
        Check console for detailed logs
      </div>
    </div>
  )
} 